// extracted by mini-css-extract-plugin
export default {"badge":"J8pffJcUrppbN-GZRSBro"};